import React from "react";
import { Calendar } from "lucide-react";

function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export default function DateField({
  id,
  name,
  label,
  value,
  onChange,
  required = false,
  min,
  max,
  ringClass = "focus:border-emerald-400 focus:ring-emerald-100",
  optional = false,
}) {
  const inputClass = `w-full pl-11 pr-4 py-3 rounded-lg border border-gray-300 bg-white focus:ring-2 outline-none text-sm text-gray-900 transition-colors ${ringClass}`;

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-semibold text-gray-800 mb-1.5">
        {label}{" "}
        {required ? (
          <span className="text-red-500">*</span>
        ) : optional ? (
          <span className="text-gray-400 font-normal text-xs">(optional)</span>
        ) : null}
      </label>
      <div className="relative">
        <Calendar
          size={16}
          className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
        />
        <input
          id={id}
          name={name}
          type="date"
          required={required}
          value={value}
          min={min}
          max={max}
          onChange={onChange}
          className={`${inputClass} [color-scheme:light] cursor-pointer`}
        />
      </div>
    </div>
  );
}

export { todayIso };
